import React from "react"; 
import Dropdown from "components/dropdown";
import { FiAlignJustify, FiSearch, FiLogOut, FiHelpCircle, FiSettings } from "react-icons/fi"; // Importa los íconos
import { Link } from "react-router-dom";
import navbarimage from "assets/img/layout/Navbar.png";
import { IoMdNotificationsOutline, IoMdInformationCircleOutline } from "react-icons/io";
import avatar from "assets/img/avatars/avatar4.png";

const Navbar = (props: {
  onOpenSidenav: () => void;
  brandText: string;
  secondary?: boolean | string;
}) => {
  const { onOpenSidenav, brandText } = props;

  const handleLogout = () => {
    console.log("Cerrando sesión...");
  };

  return (
    <nav className="sticky top-0 z-90 flex flex-row flex-wrap items-center justify-between bg-white p-2 shadow-lg">
      <div className="ml-[6px]">
        <div className="h-6 w-[524px] pt-1">
          <a className="text-sm font-normal text-navy-700 hover:underline mb-2" href=" ">
            Paginas 
            <span className="mx-1 text-sm text-navy-700"> / </span>
          </a>
          <Link className="text-sm font-normal capitalize text-navy-700 hover:underline ml-4" to="#">
            {brandText}
          </Link>
        </div>
        <p className="shrink text-[33px] capitalize text-navy-700 ml-4">
          <Link to="#" className="font-bold capitalize hover:text-navy-700">
            {brandText}
          </Link>
        </p>
      </div>

      <div className="relative flex h-[61px] w-[955px] flex-grow items-center justify-around gap-8 rounded-lg bg-white px-2 py-2 md:w-[365px] md:flex-grow-0 xl:w-[665px] xl:gap-4">
  {/* Campo de búsqueda */}
  <div className="flex h-full items-center rounded-lg bg-lightPrimary text-navy-700 xl:w-[300px]"> {/* Aumenta aquí el valor de xl:w */}
    <p className="pl-3 pr-2 text-xl">
      <FiSearch className="h-6 w-6 text-gray-600" />
    </p>
    <input
      type="text"
      placeholder="Buscar ..."
      className="block h-full w-full rounded-lg bg-lightPrimary text-sm font-medium text-navy-700 outline-none placeholder:!text-gray-300 sm:w-fit"
    />
  </div>




        <span className="flex cursor-pointer text-xl text-gray-600 xl:hidden" onClick={onOpenSidenav}>
          <FiAlignJustify className="h-6 w-6" />
        </span>

        {/* Notificaciones */}
        <Dropdown
          button={
            <p className="cursor-pointer">
              <IoMdNotificationsOutline className="h-6 w-6 text-gray-600" />
            </p>
          }
          animation="origin-[65%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
          children={
            <div className="flex w-[360px] flex-col gap-6 rounded-[20px] bg-white p-4 shadow-xl sm:w-[460px]">
              <div className="flex items-center justify-between">
                <p className="text-base font-bold text-navy-200">Notificacion</p>
                <p className="text-sm font-bold text-navy-700">Ver todas</p>
              </div>
              <button className="flex w-full items-center">
                <div className="flex h-full w-[85px] items-center justify-center rounded-xl bg-gradient-to-b from-brandLinear to-brand-500 py-4 text-2xl text-white">
                  📧
                </div>
                <div className="ml-2 flex h-full w-full flex-col justify-center rounded-lg px-1 text-sm">
                  <p className="mb-1 text-left text-base font-bold text-gray-900">Tiene un Nuevo Correo</p>
                  <p className="font-base text-left text-xs text-gray-900">Nueva alerta de descargo</p>
                </div>
              </button>
            </div>
          }
          classNames={"py-2 top-4 -left-[230px] md:-left-[440px] w-max"}
        />

        {/* Información */}
        <Dropdown
          button={
            <p className="cursor-pointer">
              <IoMdInformationCircleOutline className="h-6 w-6 text-gray-600" />
            </p>
          }
          children={
            <div className="flex w-[350px] flex-col gap-2 rounded-[20px] bg-white p-4 shadow-xl">
              <div
                style={{ backgroundImage: `url(${navbarimage})`, backgroundRepeat: "no-repeat", backgroundSize: "cover" }}
                className="mb-2 aspect-video w-full rounded-lg"
              />
              <a
                target="blank"
                href="#"
                className="px-full linear flex cursor-pointer items-center justify-center rounded-xl bg-brand-500 py-[11px] font-bold text-white transition duration-200 hover:bg-brand-600"
              >
                Como Funciona
              </a>
              <a
                target="blank"
                href="#"
                className="px-full linear flex cursor-pointer items-center justify-center rounded-xl border py-[11px] font-bold text-navy-700 transition duration-200 hover:bg-gray-200"
              >
                Ayuda
              </a>
            </div>
          }
          classNames={"py-2 top-6 -left-[250px] md:-left-[330px] w-max"}
          animation="origin-[75%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
        />

        {/* Ayuda */}
        <Dropdown
          button={
            <p className="cursor-pointer">
              <FiHelpCircle className="h-6 w-6 text-gray-600" />
            </p>
          }
          children={
            <div className="flex w-[350px] flex-col gap-2 rounded-[20px] bg-white p-4 shadow-xl">
              <p className="text-base font-bold text-navy-200">Ayuda</p>
              <p className="text-sm text-gray-600">Encuentra respuestas a tus preguntas.</p>
              {/* Puedes agregar más contenido aquí */}
            </div>
          }
          classNames={"py-2 top-6 -left-[230px] md:-left-[330px] w-max"}
          animation="origin-[75%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
        />

        {/* Configuración */}
        <Dropdown
          button={
            <p className="cursor-pointer">
              <FiSettings className="h-6 w-6 text-gray-600" />
            </p>
          }
          children={
            <div className="flex w-[350px] flex-col gap-2 rounded-[20px] bg-white p-4 shadow-xl">
              <p className="text-base font-bold text-navy-200">Configuración</p>
              <p className="text-sm text-gray-600">Ajusta tus preferencias.</p>
              {/* Puedes agregar más contenido aquí */}
            </div>
          }
          classNames={"py-2 top-6 -left-[230px] md:-left-[330px] w-max"}
          animation="origin-[75%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
        />

        {/* Perfil & Dropdown */}
        <Dropdown
          button={<img className="h-12 w-12 rounded-full" src={avatar} alt="Avatar" />}
          children={
            <div className="flex h-48 w-56 flex-col justify-start rounded-[20px] bg-white bg-cover bg-no-repeat shadow-xl">
              <div className="mt-3 ml-4">
                <div className="flex items-center gap-4">
                  <p className="text-sm font-bold text-navy-700">👋 Hola Cesar</p>
                </div>
              </div>
              <div className="mt-3 h-px w-full bg-gray-200" />
              <div className="mt-3 ml-4 flex flex-col">
                <a href=" " className="text-sm text-gray-800 hover:text-navy-700">
                  Perfil Personal
                </a>
                <a href=" " className="mt-3 text-sm text-gray-800 hover:text-navy-700">
                  Configuración
                </a>
                <a href=" " className="mt-3 text-sm text-gray-800 hover:text-navy-700">
                  Cerrar sesión
                </a>
              </div>
            </div>
          }
          classNames={"py-2 top-8 -left-[180px] w-max"}
        />
      </div>
    </nav>
  );
};

export default Navbar;
